import React from 'react';

const Loading = () => {
  return (
    <div
      className="fixed inset-0 z-[1400] flex items-center justify-center bg-black/40 backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="h-12 w-12 animate-spin rounded-full border-2 border-white/30 border-t-white" />
    </div>
  );
};

export default Loading;
